// src/components/Footer.tsx

import React, { FC, ReactElement } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useGlobalState } from '../state';

export const Footer: FC = (): ReactElement => {
  const [data, update] = useGlobalState('data');
  return (
    <Box
      sx={{
        width: "100%",
        height: "37px",
        backgroundColor: "#002984",
        // paddingTop: "1rem",
        paddingBottom: "1rem",
      }}
    >
      <Container maxWidth="lg">
        <Grid container direction="column" alignItems="center">
          <Grid item style={{height:'8px'}} xs={12}/>
          <Grid item xs={12}>
            <Typography color="secondary" variant="h6">
              Explore the Milky Way in 3D
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;